module.exports = __webpack_public_path__ + "static/media/ee_hraswo.3450328a.ogg";